import Joi from 'joi';

const schema = {
  limit: Joi.number().default(24),
  skip: Joi.number().default(0),
};

export default schema;
